export const API_General = {
    sendError: () => ({api:`/api/v1/main/errors`, method: 'POST'})
}